import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';
import type { Bruker } from '@klp/user';
import { getConfig, getRequiredConfig } from '@klpkonsern/appconfig';
import { generateApiRoute } from '@klp/core/api/helpers';
import { regionAccess } from '@klp/utils/index';

declare global {
    interface AppConfigParameters {
        WEBAPP_APP_RISIKOVURDERING_LINK: string;
        WEBAPP_APP_LEVERANDOR_ENABLE: boolean;
        WEBAPP_POWER_BI_LEVERANDOR_REPORT_URL: string;
        WEBAPP_LEVERANDOR_REGION_ENABLE?: string;
        WEBAPP_LEVERANDOR_PROSESS_DOKUMENTASON_PAGE_ID: string;
        WEBAPP_APP_SUPEROFFICE_LEVERANDOR_LINK: string;
        WEBAPP_LEVERANDOR_OTHER_COUNTRIES_ENABLE: boolean;
    }
}

export const LeverandorModuleName = 'leverandor';
const leverandorSchema = 'skjema';
const leverandorReport = 'report';
const processDefinition = 'processdefinition';
const diagram = 'diagram';
const documentation = 'documentation';
const approvedDocument = 'approveddocument';
const file = 'fil';
const processSegment = 'process' as const;
const inherentRisk = 'iboenderisiko';

export const LeverandorAccess = (currentUser?: Bruker): boolean =>
    getConfig('WEBAPP_APP_LEVERANDOR_ENABLE', false) &&
    regionAccess(currentUser, getConfig('WEBAPP_LEVERANDOR_REGION_ENABLE'));

export const RisikovurderingUrl = () =>
    getRequiredConfig('WEBAPP_APP_RISIKOVURDERING_LINK');

export const LeverandorReportUrl = () =>
    getRequiredConfig('WEBAPP_POWER_BI_LEVERANDOR_REPORT_URL');

export const LeverandorProsessDocumentationId = () =>
    getRequiredConfig('WEBAPP_LEVERANDOR_PROSESS_DOKUMENTASON_PAGE_ID');

export const LeverandorSuperofficeUrl = (superOfficeId: string) =>
    `${getConfig('WEBAPP_APP_SUPEROFFICE_LEVERANDOR_LINK')}${superOfficeId}`;

export const LeverandorReportAccess = (currentUser?: Bruker): boolean =>
    Boolean(LeverandorAccess(currentUser) && currentUser);

export const LeverandorRoutes = {
    leverandorSchema: () =>
        generateRoute([LeverandorModuleName, leverandorSchema]),
    leverandorReport: () =>
        generateRoute([LeverandorModuleName, leverandorReport]),
    leverandorSchemaSingle: (prosessInstansId: string) =>
        generateRoute([
            LeverandorModuleName,
            leverandorSchema,
            prosessInstansId,
        ]),
    download: (prosessinstansId) =>
        generateApiRoute([
            LeverandorModuleName,
            processSegment,
            approvedDocument,
            prosessinstansId,
            file,
        ]),
    processdefinitionDiagram: (processDefinitionId?: string) =>
        generateRoute([
            LeverandorModuleName,
            leverandorSchema,
            processDefinition,
            diagram,
            processDefinitionId,
        ]),
    leverandorSchemaDocumentationUrl: () =>
        generateRoute([
            LeverandorModuleName,
            leverandorSchema,
            processDefinition,
            documentation,
        ]),
    leverandorInherentRisk: () =>
        generateRoute([LeverandorModuleName, inherentRisk]),
};

export const LeverandorMenuItems = [
    new SidebarMenuItem({
        route: LeverandorRoutes.leverandorReport(),
        matchRoute: LeverandorRoutes.leverandorReport(),
        icon: IconName.GRAPH,
        translation: 'leverandor.menuItems.leverandorReport',
        access: LeverandorAccess,
    }),
    new SidebarMenuItem({
        route: LeverandorRoutes.leverandorSchema(),
        matchRoute: LeverandorRoutes.leverandorSchema(),
        icon: IconName.EDIT,
        translation: 'leverandor.menuItems.skjema',
        access: LeverandorAccess,
    }),
];

export type LeverandorViewParams = {
    prosessInstansId: string;
    superOfficeContactId: string;
};
